import { render, staticRenderFns } from "./OzCheckBox.vue?vue&type=template&id=60fc29cf&"
import script from "./OzCheckBox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzCheckBox.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports